export const Print = () => {
  return (
    <svg viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 12H1V4H17V12H16"
        stroke="currentColor"
        strokeLinejoin="round"
      />
      <rect x="4" y="1" width="10" height="3" stroke="currentColor" />
      <path
        d="M4.5 9H13.5L15 13H3L4.5 9Z"
        stroke="currentColor"
        strokeLinejoin="round"
      />
      <line x1="12" y1="6.5" x2="15.0333" y2="6.5" stroke="currentColor" />
    </svg>
  )
}
